import React from "react";
import { Route, Switch } from "react-router";
import { ListPage as SchoolListPage } from "./pages/admin/ListPage";
import { ShowPage as SchoolShowPage } from "./pages/admin/ShowPage";
import { EditPage as SchoolEditPage } from "./pages/admin/EditPage";
import { CreatePage as SchoolCreatePage } from "./pages/admin/CreatePage";
import FavoritesPage from "./pages/front/FavoritesPage";
import AuthRoute from "../auth/components/routes/AuthRoute";
import NotFound from "../pages/NotFound";
import { UserRole } from "../user/enums/UserRole";

export function Schools({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
          component={SchoolListPage}
        />
        <AuthRoute
          exact
          path={`${path}/favorites`}
          roles={[UserRole.Agent, UserRole.Parent, UserRole.Student]}
          component={FavoritesPage}
        />
        <AuthRoute
          exact
          roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
          component={SchoolCreatePage}
          path={`${path}/create`}
        />
        <AuthRoute
          exact
          roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
          component={SchoolShowPage}
          path={`${path}/:id`}
        />
        <AuthRoute
          exact
          roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
          component={SchoolEditPage}
          path={`${path}/:id/edit`}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
